import styled from 'styled-components';
import { IconCheckmark, spaceMixin, token } from '@zillow/constellation';

export const StyledIconCheckmark = styled(IconCheckmark)`
  display: table-cell;
  vertical-align: middle;
  text-align: center;

  && {
    height: 14px;
    width: 14px;
  }
`;

export const StyledStepContainer = styled.div<{ isActive: boolean; isCompleted: boolean }>`
  z-index: 2;
  border-radius: 50%;
  margin-top: ${(props) => (props.isActive || props.isCompleted ? '2px' : '10px')};
  border: 8px solid ${(props) => (props.isActive ? 'rgba(7, 77, 255, 0.1)' : 'transparent')};
`;

export const StyledStep = styled.div`
  border-radius: 50%;
  border-width: 6px;
  border-style: solid;
  height: 20px;
  width: 20px;
  color: ${token('colors.white')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInactiveStep = styled(StyledStep)`
  border-width: 1px;
  height: ${spaceMixin(0.5)};
  width: ${spaceMixin(0.5)};
  background-color: ${token('colors.white')};
`;

export const StyledCustomStep = styled(StyledStep)<{ borderColor: string; backgroundColor: string }>`
  && {
    border-width: 3px;
    border-color: ${(props) => props.borderColor};
    background-color: ${(props) => props.backgroundColor};
  }
`;

export const StyledActiveStep = styled(StyledStep)`
  && {
    border-color: ${token('colors.white')};
    background-color: ${token('colors.brand')};
    box-shadow: 0px 2px 4px rgba(33, 29, 29, 0.2);
  }
`;
